import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

import * as Styled from './ExpressionSection.styles';

import { useProductLandingContext } from '../../contexts/useProductLanding';

function ExpressionSection() {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { productConfig } = useProductLandingContext();
  const { expression } = productConfig;

  if (!expression) {
    return null;
  }

  const { title, description, image } = expression;
  const imageUrl = isMobile ? image?.srcMobile : image?.src;

  return (
    <Stack gap={{ xs: 2, md: 3 }}>
      {title && (
        <Heading size="xl">
          <FormattedMessage id={title} />
        </Heading>
      )}
      <Styled.Image
        alt={image.alt ? formatMessage({ id: image.alt }) : ''}
        src={imageUrl}
        sx={{ borderRadius: theme.shape.rounded.lg }}
      />
      {description && (
        <Text size="xs" color="tertiary">
          <FormattedMessage id={description} />
        </Text>
      )}
    </Stack>
  );
}

export default ExpressionSection;
